import { oktaAuth } from "services/okta";

export const defaultHeaders = {
  "Content-Type": "application/json",
};

interface AuthHeaders {
  Authorization: string;
}

export const getAccessToken = (): string | undefined => {
  const token = oktaAuth.getAccessToken();

  if (!token) {
    console.error("missing user access token");
  }

  return token;
};

export const getAuthHeaders = (): AuthHeaders => ({
  Authorization: `Bearer ${getAccessToken()}`,
});
